import { Field } from 'formik';
const StrictNumberField = (props) => {
    return (
        <Field
            {...props}
            onFocus={(e)=>{e.target.select()}}
            onKeyDown={(e) => {
                (["e", "E", "+", "-"].includes(e.key) || (e.target.value === '' && e.key === '.')) && e.preventDefault()
                props.onKeyDown();
            }}
        />
    )
}
StrictNumberField.defaultProps = {
    onKeyDown: () => { }
}
export default StrictNumberField;